import { render, staticRenderFns } from "./WallpaperManagementV2.vue?vue&type=template&id=21c5646c&scoped=true&"
import script from "./WallpaperManagementV2.vue?vue&type=script&lang=js&"
export * from "./WallpaperManagementV2.vue?vue&type=script&lang=js&"
import style0 from "./WallpaperManagementV2.vue?vue&type=style&index=0&id=21c5646c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c5646c",
  null
  
)

export default component.exports